import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PulldownModule } from '../pulldown/pulldown.module';
import { FormComponent } from './components/form/form.component';
import { LoginComponent } from './components/login/login.component';
import { ResendComponent } from './components/resend/resend.component';
import { LasuiteRegisterComponent } from './lasuite-register.component';

@NgModule({
  declarations: [
    LasuiteRegisterComponent,
    FormComponent,
    ResendComponent,
    LoginComponent,
  ],
  exports: [LasuiteRegisterComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    SharedModule,
    PulldownModule,
  ],
})
export class LasuiteRegisterModule {}
